<template>
    <div>
        <free-gifts-delete-dialog
            v-if="isEditMode"
            :resource="freeGiftsResource"
            :resource-id="freeGiftId"
            :child-dependencies-warning="false"
        />
        <delete-button v-else background @delete="cancelCreation" />
    </div>
</template>

<script>
import resources from '@enums/resources';
import { isFunction } from 'lodash';

export default {
    data() {
        return {
            freeGiftsResource: resources.freeGifts,
        };
    },
    computed: {
        freeGiftId() {
            return this.params.data._id;
        },
        isEditMode() {
            return this.freeGiftId;
        },
    },
    methods: {
        cancelCreation() {
            const selectedNode = this.params.node;
            const selectedData = selectedNode.data;
            this.params.api.applyTransaction({ remove: [selectedData] });

            if (isFunction(this.params.onCancelCreation)) {
                this.params.onCancelCreation();
            }
        },
    },
};
</script>
